import { atsApiQuery } from '..';

export const requestReviewApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getReviewActionDetails: builder.query({
        transformResponse: (response) => response.data,
        query: (params = {}) => {
          return { method: 'get', url: `/ats_reviews/new`, params };
        },
      }),
      sendReview: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ payload }) => {
          return { method: 'post', url: `/ats_reviews/`, data: payload };
        },
      }),
      getReviewDetails: builder.query({
        transformResponse: (response) => response.data,
        query: ({ reviewId }) => {
          return { method: 'get', url: `/ats_reviews/${reviewId}` };
        },
        providesTags: (result, error, { reviewId }) => [
          { type: 'ReviewDetails', id: reviewId },
        ],
      }),
      updateReview: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ payload, reviewId }) => {
          return {
            method: 'put',
            url: `/ats_reviews/${reviewId}`,
            data: payload,
          };
        },
        invalidatesTags: (result, error, { reviewId }) => [
          { type: 'ReviewDetails', id: reviewId },
        ],
      }),
      deleteReview: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ reviewId }) => {
          return { method: 'delete', url: `/ats_reviews/${reviewId}` };
        },
      }),
      createAdhocReview: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ payload }) => {
          const { ats_job_stage_id, ats_application_id, params } = payload;

          return {
            method: 'post',
            url: `/ats_reviews/create_adhoc_review`,
            data: {
              ats_job_stage_id,
              ats_application_id,
              ...params,
            },
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetReviewActionDetailsQuery,
  useSendReviewMutation,
  useDeleteReviewMutation,
  useGetReviewDetailsQuery,
  useUpdateReviewMutation,
  useCreateAdhocReviewMutation,
} = requestReviewApi;
